"use strict";

exports.__esModule = true;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var localStorage = {};

exports.default = {
  setItem: function setItem(key, value) {
    return (0, _assign2.default)(localStorage, (0, _defineProperty3.default)({}, key, value));
  },
  getItem: function getItem(key) {
    return localStorage[key];
  },
  clear: function clear() {
    localStorage = {};
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/services/localstorage.mock.js
// module id = 992
// module chunks = 0